/* Yachew Christmas Shop 2026 (xm26). No dependencies. Every feature no-ops when its markup is absent. */
(function () {
  'use strict';
  var d = document;
  /* Measurement: every Christmas-shop event goes to GA4 (the theme's gtag) and to Shopify customer events,
     tagged with which page (postal, street, ...) and where on it, so we can see what actually sells. */
  var xmView = (location.search.match(/[?&]view=xmas26-?([a-z0-9-]*)/) || [])[1] || 'main';
  window.xm26Track = window.xm26Track || function (name, params) {
    var p = { xm_page: xmView }; for (var k in params || {}) p[k] = params[k];
    try { if (typeof window.gtag === 'function') window.gtag('event', name, p); } catch (e) {}
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(name, p); } catch (e) {}
  };
  // Referral links (?ref=CODE from someone's cracker): keep the code and put it on the cart, so the order carries it.
  (function () {
    var m = location.search.match(/[?&]ref=([A-Za-z2-9]{7})(?:&|$)/), code = m ? m[1].toUpperCase() : null;
    try { if (code) localStorage.setItem('xm26-ref', code); else code = localStorage.getItem('xm26-ref'); } catch (e) {}
    if (!code) return;
    fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) {
      if ((c.attributes || {})._xm26_ref === code) return;
      return fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ attributes: { _xm26_ref: code } }) });
    }).catch(function () {});
    if (m && window.xm26Track) window.xm26Track('xmas26_referral_visit', {});
  })();
  var cur = (window.Shopify && Shopify.currency) || { active: 'GBP', rate: '1.0' };
  var money = function (cents) {
    try { return new Intl.NumberFormat(d.documentElement.lang || 'en-GB', { style: 'currency', currency: cur.active }).format(cents / 100); }
    catch (e) { return (cents / 100).toFixed(2); }
  };
  // A GBP amount written into copy ("every £10") becomes a clean local figure: nearest whole unit under 10, nearest 5 above.
  function cleanLocal(gbp) { var r = parseFloat(cur.rate || 1), v = gbp * r; if (cur.active === 'GBP') return Math.round(gbp * 100); v = v < 10 ? Math.round(v) : Math.round(v / 5) * 5; return v * 100; }
  var store = {
    get: function (k) { try { return localStorage.getItem(k); } catch (e) { return null; } },
    set: function (k, v) { try { localStorage.setItem(k, v); } catch (e) {} }
  };
  var smooth = matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
  var isPreview = /[?&]view=xmas26\b/.test(location.search) || (window.Shopify && Shopify.designMode);
  d.querySelectorAll('[data-xm-preview-only]').forEach(function (el) { if (isPreview) el.hidden = false; });

  /* ── Sticky offset: sit the chip nav under the theme's sticky header ── */
  function stickyTop() {
    // Stack under whatever the theme pins to the top (header group sections, sticky-header).
    var top = 0;
    d.querySelectorAll('.shopify-section-group-header-group, sticky-header, .header-wrapper').forEach(function (el) {
      var p = getComputedStyle(el).position;
      if (p !== 'sticky' && p !== 'fixed') return;
      var r = el.getBoundingClientRect();
      if (!(r.top <= 1 && r.height > 0 && r.height < innerHeight / 2)) return;
      // The header box keeps its full height when the theme slides the menu row away on scroll,
      // so measure the rows that are actually showing, not the box.
      var bottom = r.top, rows = el.querySelectorAll('.header-row');
      if (rows.length) rows.forEach(function (row) { if (getComputedStyle(row).visibility === 'hidden') return; var rr = row.getBoundingClientRect(); if (rr.height > 0 && rr.bottom > bottom) bottom = rr.bottom; });
      else bottom = r.bottom;
      if (bottom > top) top = bottom;
    });
    top = Math.round(top); if (top === lastTop) return; lastTop = top;
    d.documentElement.style.setProperty('--xm-sticky-top', top + 'px');
  }
  var ticking = false, lastTop = -1, settle;
  function queueTop() { if (ticking) return; ticking = true; requestAnimationFrame(function () { ticking = false; stickyTop(); }); clearTimeout(settle); settle = setTimeout(stickyTop, 420); }
  stickyTop(); addEventListener('resize', queueTop, { passive: true });
  addEventListener('scroll', queueTop, { passive: true });
  d.addEventListener('transitionend', function (e) { if (e.target.closest && e.target.closest('.shopify-section-group-header-group, sticky-header, .header-wrapper')) stickyTop(); }, true);

  /* ── Order-by dates ── */
  var cfgEl = d.getElementById('xm26-delivery');
  var CFG = null; try { CFG = cfgEl && JSON.parse(cfgEl.textContent); } catch (e) {}
  var NAMES = {};
  try { var dn = new Intl.DisplayNames(['en-GB'], { type: 'region' }); } catch (e) { dn = null; }
  function cname(c) { return NAMES[c] || (NAMES[c] = (dn && dn.of(c)) || c); }
  function subBusinessDays(ymd, n) { var x = new Date(Date.UTC(ymd[0], ymd[1] - 1, ymd[2])); while (n > 0) { x.setUTCDate(x.getUTCDate() - 1); var w = x.getUTCDay(); if (w !== 0 && w !== 6) n--; } return [x.getUTCFullYear(), x.getUTCMonth() + 1, x.getUTCDate()]; }
  var ISO = /^(\d{4})-(\d{2})-(\d{2})$/;
  function ymdOf(str) { var m = ISO.exec(str || ''); return m ? [+m[1], +m[2], +m[3]] : null; }
  // All dates are UK calendar dates; the order must be in by 12:00 UK time (GMT all December) on that day.
  function bufferFor(c) { var b = CFG.bufferBy && CFG.bufferBy[c]; return b != null ? b : (CFG.buffer || 0); }
  function orderBy(c, target) {
    if (!CFG) return null;
    var o = !target && CFG.overrides && ymdOf(CFG.overrides[c]);
    var t = ymdOf(target || CFG.target);
    var ymd = o || (CFG.map[c] && t && subBusinessDays(t, CFG.map[c][1] + bufferFor(c)));
    if (!ymd) return null;
    return { ymd: ymd, cutoff: Date.UTC(ymd[0], ymd[1] - 1, ymd[2], 12), date: new Date(Date.UTC(ymd[0], ymd[1] - 1, ymd[2], 12)), confirmed: !!o };
  }
  var ukToday = (function () {
    try { var p = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/London', year: 'numeric', month: '2-digit', day: '2-digit' }).formatToParts(new Date()), g = function (t) { return +p.filter(function (x) { return x.type === t; })[0].value; }; return Date.UTC(g('year'), g('month') - 1, g('day')); }
    catch (e) { var n = new Date(); return Date.UTC(n.getUTCFullYear(), n.getUTCMonth(), n.getUTCDate()); }
  })();
  function daysLeft(ob) { if (Date.now() >= ob.cutoff) return -1; return Math.round((Date.UTC(ob.ymd[0], ob.ymd[1] - 1, ob.ymd[2]) - ukToday) / 864e5); }
  // The page copy is English in every market, so dates read in English too (no "Do., 17. Dezember" mid-sentence).
  var lang = 'en-GB';
  var fmt = function (dt) { return dt.toLocaleDateString(lang, { weekday: 'long', day: 'numeric', month: 'long', timeZone: 'UTC' }); };
  var fmtShort = function (dt) { return dt.toLocaleDateString(lang, { weekday: 'short', day: 'numeric', month: 'short', timeZone: 'UTC' }); };
  var fmtLocalTime = function (ms) { try { return new Date(ms).toLocaleTimeString(lang, { hour: 'numeric', minute: '2-digit' }); } catch (e) { return ''; } };
  var known = CFG ? Object.keys(CFG.map).concat(Object.keys(CFG.overrides || {}).filter(function (k) { return !CFG.map[k]; })) : [];
  // A country picked in the hero only sticks while the shopper stays on the same store region: it is saved
  // with the region it was picked on, so switching region in the header (or an old pick from another region) falls back to the region.
  var base = (CFG && CFG.country) || '', saved = (store.get('xm26-country') || '').split('@');
  var you = (saved.length === 2 && saved[1] === base && saved[0]) || base;
  if (known.indexOf(you) < 0) you = '';
  if (you === 'US' || you === 'CA') lang = lang.replace(/^en(-GB)?$/, 'en-US');

  function renderHero() {
    var box = d.querySelector('[data-xm-orderby]'); if (!box || !CFG) return;
    var sel = box.querySelector('select');
    if (!sel.options.length) {
      var ph = d.createElement('option'); ph.value = ''; ph.textContent = 'choose your country'; sel.appendChild(ph);
      known.map(function (c) { return [c, cname(c)]; }).sort(function (a, b) { return a[1].localeCompare(b[1]); })
        .forEach(function (p) { var o = d.createElement('option'); o.value = p[0]; o.textContent = p[1]; sel.appendChild(o); });
      sel.addEventListener('change', function () { you = sel.value; store.set('xm26-country', you + '@' + base); renderHero(); renderDates(); d.dispatchEvent(new CustomEvent('xm26:country', { detail: you })); });
    }
    sel.value = you;
    var dateEl = box.querySelector('[data-xm-date]'), daysEl = box.querySelector('[data-xm-days]'), lead = box.querySelector('[data-xm-lead]'), mid = box.querySelector('[data-xm-mid]'), note = box.querySelector('[data-xm-note]');
    var ob = you && orderBy(you);
    if (!ob) { lead.textContent = 'See the last day to order'; dateEl.textContent = ''; mid.textContent = ' for Christmas in'; daysEl.textContent = ''; note.textContent = ''; box.setAttribute('data-ready', ''); stampPostmark(null); return; }
    var left = daysLeft(ob);
    if (left >= 0) {
      lead.textContent = 'Order by';
      dateEl.textContent = left === 0 ? 'midday UK time today (' + fmtLocalTime(ob.cutoff) + ' your time)' : fmtShortLong(ob.date);
      mid.textContent = ' for Christmas in';
      daysEl.textContent = (left === 0 ? 'Last day' : left === 1 ? '1 day to go' : left + ' days to go') + (ob.confirmed ? '' : ', estimated');
    } else {
      lead.textContent = 'The last Christmas post has gone';
      dateEl.textContent = '';
      mid.textContent = ' to';
      daysEl.textContent = '';
    }
    note.textContent = (ob.confirmed ? 'Based on Royal Mail’s last posting dates.' : 'Estimated from usual delivery times, with extra days for the Christmas rush.') + ' Orders by 12:00 UK time go out that day.';
    box.setAttribute('data-ready', '');
    stampPostmark(ob);
  }
  var pmFirst = true;
  function stampPostmark(ob) {
    var pm = d.querySelector('[data-xm-postmark]'); if (!pm) return;
    var ring = pm.querySelector('[data-xm-pm-ring]'), day = pm.querySelector('[data-xm-pm-day]'), mon = pm.querySelector('[data-xm-pm-mon]');
    if (ob) {
      var to = pm.querySelector('[data-xm-pm-to]');
      if (to) { var cn = cname(you).toUpperCase(); to.textContent = 'TO ' + cn; to.parentNode.style.fontSize = cn.length > 14 ? '7.5px' : ''; }
      else if (ring) ring.textContent = ('Posted in the UK ★ to ' + cname(you) + ' ★ ').toUpperCase();
      day.textContent = ob.ymd[2]; mon.textContent = ob.date.toLocaleDateString('en-GB', { month: 'short', timeZone: 'UTC' }).toUpperCase();
    }
    if (!matchMedia('(prefers-reduced-motion: reduce)').matches && (!pmFirst || !sessionStorageGet('xm26-pm'))) {
      pm.classList.remove('is-thump'); void pm.getBoundingClientRect(); pm.classList.add('is-thump');
      try { sessionStorage.setItem('xm26-pm', '1'); } catch (e) {}
    }
    pmFirst = false;
  }
  function sessionStorageGet(k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } }
  var fmtShortLong = function (dt) { return dt.toLocaleDateString(lang, { weekday: 'short', day: 'numeric', month: 'long', timeZone: 'UTC' }); };

  var showAll = false;
  function renderDates() {
    var list = d.querySelector('[data-xm-dates]'); if (!list || !CFG) return;
    var rows = known.map(function (c) { var ob = orderBy(c); return ob && { c: c, ob: ob, left: daysLeft(ob) }; }).filter(Boolean)
      .sort(function (a, b) { return a.ob.date - b.ob.date || cname(a.c).localeCompare(cname(b.c)); });
    var max = Math.max.apply(null, rows.map(function (r) { return r.left; })) || 1;
    var mine = rows.filter(function (r) { return r.c === you; });
    var shown = showAll ? rows : mine.concat(rows.filter(function (r) { return r.c !== you; }).slice(0, 7));
    list.innerHTML = shown.map(function (r) {
      var cls = (r.c === you ? 'is-you ' : '') + (r.left < 0 ? 'is-past' : '');
      var w = r.left < 0 ? 0 : Math.max(3, Math.round(100 * r.left / max));
      return '<li class="' + cls + '"><span>' + cname(r.c) + (r.c === you ? ' <span class="xm__sr">(your country)</span>' : '') + '</span><span>' +
        (r.left < 0 ? 'Missed' : fmtShort(r.ob.date)) + '</span><span class="xm-dates__bar" title="' + Math.max(0, r.left) + ' days left"><i style="width:' + w + '%"></i></span></li>';
    }).join('');
    var more = d.querySelector('[data-xm-dates-more]');
    if (more) { more.textContent = showAll ? 'Show fewer countries' : 'Show all ' + rows.length + ' countries'; more.onclick = function () { showAll = !showAll; renderDates(); }; }
  }
  function renderDeadlines() {
    d.querySelectorAll('[data-xm-deadline]').forEach(function (el) {
      var ob = you && orderBy(you, el.getAttribute('data-xm-deadline'));
      if (!ob) { el.hidden = true; return; }
      var left = daysLeft(ob);
      el.textContent = left < 0 ? 'Too late ' + el.getAttribute('data-xm-deadline-label') + ' to ' + cname(you) + ', but still in time for Christmas.'
        : 'Order by ' + fmt(ob.date) + ' ' + el.getAttribute('data-xm-deadline-label') + ' to ' + cname(you) + '.';
      el.hidden = false;
    });
  }
  function renderClose() {
    var t = d.querySelector('[data-xm-close-title]'); if (!t || t.hasAttribute('data-keep')) return;
    var ob = you && orderBy(you); if (!ob || daysLeft(ob) < 0) return;
    t.textContent = ''; t.append('Order by '); var st = d.createElement('strong'); st.textContent = fmtShortLong(ob.date); t.appendChild(st); t.append(' for Christmas in ' + cname(you) + '.');
  }
  renderHero(); renderDates(); renderDeadlines(); renderClose();
  d.addEventListener('xm26:country', renderClose);
  var closeEl = d.querySelector('[data-xm-close]');
  if (closeEl && 'IntersectionObserver' in window) { var cio = new IntersectionObserver(function (es) { if (es[0].isIntersecting) { closeEl.classList.add('is-in'); cio.disconnect(); } }, { threshold: 0.3 }); cio.observe(closeEl); } else if (closeEl) closeEl.classList.add('is-in');

  /* Postal direction: string dividers draw themselves in; tag buttons read "Add to parcel" */
  var strings = d.querySelectorAll('[data-xm-string]');
  if (strings.length && 'IntersectionObserver' in window) {
    var sio = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); sio.unobserve(e.target); } }); }, { threshold: 0.6 });
    strings.forEach(function (x) { sio.observe(x); });
  } else strings.forEach(function (x) { x.classList.add('is-in'); });
  if (d.querySelector('.xm-phero')) d.querySelectorAll('.xm-rail .xm-card__add[data-xm-add] span').forEach(function (sp) { sp.textContent = 'Add to parcel'; });

  /* Prices written into copy ("£10", "Under £25") follow the shopper's currency, rounded to a clean figure */
  if (cur.active !== 'GBP') {
    var r0 = parseFloat(cur.rate || 1);
    var clean = function (gbp) { var v = cleanLocal(gbp) / 100; try { return new Intl.NumberFormat(lang, { style: 'currency', currency: cur.active, maximumFractionDigits: 0 }).format(v); } catch (e) { return String(v); } };
    d.querySelectorAll('[data-xm-money-text]').forEach(function (el) {
      [].slice.call(el.childNodes).forEach(function (n) { if (n.nodeType === 3) n.textContent = n.textContent.replace(/£(\d+(?:\.\d+)?)/g, function (_, n1) { return clean(+n1); }); });
    });
  }
  d.addEventListener('xm26:country', renderDeadlines);

  /* ── Chip nav: highlight the section under the upper third of the screen ── */
  var nav = d.querySelector('[data-xm-nav]');
  if (nav) {
    var links = [].slice.call(nav.querySelectorAll('a[href^="#"]'));
    links = links.filter(function (a) { var t = d.getElementById(a.getAttribute('href').slice(1)); if (!t || t.hidden || t.closest('[hidden]')) { a.remove(); return false; } return true; });
    // Chips follow the order of the page.
    links.sort(function (a, b) { var ta = d.getElementById(a.getAttribute('href').slice(1)), tb = d.getElementById(b.getAttribute('href').slice(1)); return ta.compareDocumentPosition(tb) & 2 ? 1 : -1; });
    var row = nav.querySelector('.xm-nav__row'); links.forEach(function (a) { row.appendChild(a); });
    var current = null, spyTick = false;
    function spy() {
      spyTick = false;
      var line = innerHeight * 0.35, pick = null;
      links.forEach(function (a) { var t = d.getElementById(a.getAttribute('href').slice(1)); var r = t.getBoundingClientRect(); if (r.top <= line && r.bottom > line) pick = a; });
      if (pick === current) return; current = pick;
      links.forEach(function (a) { a.setAttribute('aria-current', a === pick ? 'true' : 'false'); });
      if (pick) row.scrollTo({ left: Math.max(0, pick.offsetLeft - 16), behavior: smooth });
    }
    addEventListener('scroll', function () { if (!spyTick) { spyTick = true; requestAnimationFrame(spy); } }, { passive: true }); spy();
  }

  /* ── Rails: no product more than twice on the page ── */
  (function () {
    var seen = {};
    d.querySelectorAll('.xm-rail .xm-card').forEach(function (c) {
      var a = c.querySelector('.xm-card__title'); if (!a) return; var k = a.getAttribute('href').split('?')[0];
      seen[k] = (seen[k] || 0) + 1;
      if (seen[k] > 2 && c.closest('.xm-rail__track').children.length > 6) (c.closest('[role=listitem]') || c).remove();
    });
  })();

  /* ── Rails ── */
  d.querySelectorAll('[data-xm-rail]').forEach(function (rail) {
    var track = rail.querySelector('.xm-rail__track'), prev = rail.parentElement.querySelector('[data-xm-prev]'), next = rail.parentElement.querySelector('[data-xm-next]'), bar = rail.querySelector('.xm-rail__progress i');
    function upd() {
      var max = track.scrollWidth - track.clientWidth;
      if (prev) prev.disabled = track.scrollLeft < 4;
      if (next) next.disabled = track.scrollLeft > max - 4;
      if (bar) { var vis = track.clientWidth / track.scrollWidth; bar.style.width = (vis * 100) + '%'; bar.style.transform = 'translateX(' + (max > 0 ? (track.scrollLeft / max) * (1 / vis - 1) * 100 : 0) + '%)'; }
    }
    function go(dir) { track.scrollBy({ left: dir * track.clientWidth * 0.9, behavior: smooth }); }
    prev && prev.addEventListener('click', function () { go(-1); });
    next && next.addEventListener('click', function () { go(1); });
    track.addEventListener('scroll', upd, { passive: true }); addEventListener('resize', upd); upd();
  });

  /* ── Basket (spend-and-get) bar ── */
  var bEl = d.querySelector('[data-xm-basket]');
  var B = null; try { B = bEl && JSON.parse(bEl.getAttribute('data-xm-basket')); } catch (e) {}
  if (B && !(B.step > 0)) B.step = 10;
  if (B && !(B.threshold > 0)) B.threshold = 40;
  var bDismissed = false; try { bDismissed = sessionStorage.getItem('xm26-basket-x') === '1'; } catch (e) {}
  function paintBasket(cart) {
    if (!bEl || !B || bEl.hidden || bDismissed || !cart) return;
    var rate = parseFloat(cur.rate || 1);
    var total = cart.items_subtotal_price != null ? cart.items_subtotal_price : cart.total_price;
    if (!cart.item_count) { bEl.classList.remove('is-on'); return; }
    var msg = bEl.querySelector('.xm-basket__msg'), note = bEl.querySelector('.xm-basket__note'), bar = bEl.querySelector('.xm-basket__track i');
    if (B.mode === 'tickets') {
      var step = cleanLocal(B.step), n = Math.floor(total / step), next = step - (total % step), nn = n + 1, cap = false;
      // Same rules as the cart drawer line and the server (early-bird double, US daily cap) when xm26-cart-tickets.js is loaded.
      if (window.xm26Tickets) { var tt = window.xm26Tickets(total); n = tt.n; next = tt.next; nn = tt.nextN; cap = tt.atCap; }
      msg.innerHTML = n ? 'This basket earns <strong>' + n + (n === 1 ? ' ticket' : ' tickets') + '</strong> in the Christmas draw.' + (cap ? ' That\u2019s the most for one day.' : ' Add ' + money(next) + ' for ' + nn + '.')
                        : 'Add <strong>' + money(next) + '</strong> to earn your first ' + (nn > 1 ? nn + ' tickets' : 'ticket') + ' in the Christmas draw.';
      note.textContent = B.note || '';
      bar.style.width = Math.round(100 * (total % step) / step) + '%';
      var pips = bEl.querySelector('.xm-basket__pips'); if (pips) pips.innerHTML = new Array(Math.min(n, 12) + 1).join('<i></i>');
      fillTray(next, cart);
      bEl.classList.toggle('is-won', false);
    } else {
      var goal = Math.round(B.threshold * 100 * rate);
      var pct = Math.min(100, Math.round(100 * total / goal));
      msg.textContent = '';
      var strong = d.createElement('strong');
      if (total >= goal) { bEl.classList.add('is-won'); strong.textContent = B.won; msg.appendChild(strong); }
      else { bEl.classList.remove('is-won'); msg.append('Spend '); strong.textContent = money(goal - total); msg.appendChild(strong); msg.append(' more for ' + B.reward); }
      note.textContent = '';
      bar.style.width = pct + '%';
    }
    bEl.classList.add('is-on');
    var view = bEl.querySelector('[data-xm-view]'); if (view) view.hidden = !cart.item_count;
  }
  var HOT = ['AU', 'NZ', 'SG', 'HK', 'AE'];
  function fillTray(gap, cart) {
    var tray = bEl.querySelector('[data-xm-tray]'), toggle = bEl.querySelector('[data-xm-tray-toggle]'); if (!tray) return;
    var inCart = (cart.items || []).map(function (i) { return String(i.variant_id); });
    var hot = HOT.indexOf(you || (CFG && CFG.country)) > -1;
    var items = [].slice.call(tray.querySelectorAll('[data-xm-topup]')).filter(function (el) {
      var add = el.querySelector('[data-xm-add]');
      return add && inCart.indexOf(add.getAttribute('data-xm-add')) < 0 && !(hot && el.getAttribute('data-hot-ok') === '0');
    });
    // Cheapest items that close the gap first, then the dearest of the rest.
    var price = function (el) { return +el.querySelector('.xm-card').getAttribute('data-price'); };
    var over = items.filter(function (el) { return price(el) >= gap; }).sort(function (a, b) { return price(a) - price(b); });
    var under = items.filter(function (el) { return price(el) < gap; }).sort(function (a, b) { return price(b) - price(a); });
    var show = over.concat(under).slice(0, 4);
    tray.querySelectorAll('[data-xm-topup]').forEach(function (el) { el.hidden = show.indexOf(el) < 0; });
    show.forEach(function (el) { tray.insertBefore(el, tray.querySelector('[data-xm-tray-hint]')); });
    var hint = tray.querySelector('[data-xm-tray-hint]'); if (hint) hint.textContent = over.length ? 'Any of the first ' + Math.min(over.length, 4) + ' gets you the next ticket.' : '';
    toggle.hidden = !show.length;
  }
  var addedTimer = 0;
  function refreshBasket(addedTitle) {
    if (!bEl || bEl.hidden) return;
    fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
      if (addedTitle && addedTitle.textContent && bDismissed) { bDismissed = false; }
      paintBasket(cart);
      if (addedTitle && addedTitle.textContent) {
        var note = bEl.querySelector('.xm-basket__note'); note.textContent = 'Added: ' + addedTitle.textContent.trim();
        bEl.classList.add('is-added'); clearTimeout(addedTimer); addedTimer = setTimeout(function () { bEl.classList.remove('is-added'); if (B) note.textContent = B.note || ''; }, 3500);
      }
    }).catch(function () {});
  }
  if (bEl) {
    var view = bEl.querySelector('[data-xm-view]');
    if (view) view.addEventListener('click', function (e) { var cd = d.querySelector('cart-drawer'); if (cd && cd.open) { e.preventDefault(); cd.open(); } });
    var tgl = bEl.querySelector('[data-xm-tray-toggle]');
    if (tgl) tgl.addEventListener('click', function (e) { e.stopPropagation(); var open = !bEl.classList.contains('is-open'); bEl.classList.toggle('is-open', open); tgl.setAttribute('aria-expanded', open); tgl.textContent = open ? 'Close' : 'Top up'; });
    bEl.querySelector('.xm-basket__x').addEventListener('click', function () { bDismissed = true; try { sessionStorage.setItem('xm26-basket-x', '1'); } catch (x) {} bEl.classList.remove('is-on'); });
    refreshBasket();
    // The theme's own add-to-cart and drawer edits also move the total.
    try { if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') subscribe(PUB_SUB_EVENTS.cartUpdate, refreshBasket); } catch (e) {}
    var drawer = d.querySelector('cart-drawer');
    if (drawer && window.MutationObserver) { var t; new MutationObserver(function () { clearTimeout(t); t = setTimeout(refreshBasket, 400); }).observe(drawer, { childList: true, subtree: true }); }
  }

  /* ── Quick add ── */
  var live = d.createElement('div'); live.className = 'xm__sr'; live.setAttribute('role', 'status'); live.setAttribute('aria-live', 'polite'); d.body.appendChild(live);
  function quietRender(cart, res) {
    if (!cart || !res || !res.sections) return;
    cart.classList.remove('is-empty');
    var inner = cart.querySelector('.cart-drawer__inner'); if (inner) inner.classList.remove('is-empty');
    try {
      cart.getSectionsToRender().forEach(function (sec) {
        var html = res.sections[sec.id]; if (!html) return;
        var target = sec.selector ? d.querySelector(sec.selector) : d.getElementById(sec.id); if (!target) return;
        var src = new DOMParser().parseFromString(html, 'text/html').querySelector(sec.selector || '.shopify-section'); if (src) target.innerHTML = src.innerHTML;
      });
      var ov = d.getElementById('CartDrawer-Overlay'); if (ov && cart.close) ov.addEventListener('click', cart.close.bind(cart, false));
    } catch (e) { cart.renderContents(res); }
  }
  function announce(t) { live.textContent = ''; setTimeout(function () { live.textContent = t; }, 50); }
  // Free entry to the draw (when the prize section has an endpoint): posts to the draw API, which emails a confirmation link.
  // Countries the draw isn't open in see that before they enter or buy.
  (function () {
    // Same allow-list as the draw (src/backend/services/christmasDraw/config.js ALLOWED_COUNTRIES).
    var OPEN = ['GB', 'US', 'CA', 'AU', 'NZ', 'IE', 'DE', 'FR', 'NL', 'BE', 'LU', 'AT', 'DK', 'SE', 'NO', 'FI', 'IS', 'CH', 'ES', 'PT'], c = String((window.Shopify && Shopify.country) || '').toUpperCase();
    var nameOf = function (cc) { try { return new Intl.DisplayNames(['en-GB'], { type: 'region' }).of(cc); } catch (e) { return 'your country'; } };
    var closed = d.querySelector('[data-xm-draw-closed]'), wrap = d.querySelector('[data-xm-draw-endpoint]'), form = wrap && wrap.querySelector('form');
    if (c && OPEN.indexOf(c) < 0) {
      if (closed) { closed.textContent = 'Our Christmas draw isn\u2019t open to entries from ' + nameOf(c) + ', sorry. Every order still comes with a cracker: a paper crown and a terrible joke.'; closed.hidden = false; }
      if (wrap) wrap.hidden = true;
      return;
    }
    if (!form || !wrap.getAttribute('data-xm-draw-endpoint')) return;
    var api = wrap.getAttribute('data-xm-draw-endpoint').replace(/\/$/, ''), msg = form.querySelector('[data-xm-draw-msg]');
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var email = form.querySelector('input[type=email]').value, btn = form.querySelector('button[type=submit]');
      btn.disabled = true;
      fetch(api + '/free-entry', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, credentials: 'omit',
        body: JSON.stringify({ email: email, country: (form.querySelector('[data-xm-country-res]') || {}).value || c, adult: !!(form.querySelector('[data-xm-adult]') || {}).checked,
          consentMarketing: !!(form.querySelector('[data-xm-optin]') || {}).checked, terms: !!(form.querySelector('[data-xm-terms]') || {}).checked }) })
        .then(function (r) { return r.json(); })
        .then(function (j) {
          msg.hidden = false;
          var errs = { invalid_email: 'That email address doesn\u2019t look right.', disposable_email: 'Please use your own email address, not a temporary one.',
            closed: 'The draw has closed. Happy Christmas!', not_open_in_country: 'Sorry, the draw isn\u2019t open to people living there.', age_required: 'You need to be 18 or over to enter.',
            terms_required: 'Please tick to accept the draw terms.', too_many_today: 'We\u2019ve had a lot of entries from this connection today. Try again tomorrow.', rate_limited: 'Too many tries. Please wait a few minutes.' };
          msg.textContent = !j.ok ? (errs[j.error] || 'That didn\u2019t work. Please try again.')
            : j.alreadyToday && j.confirmed ? 'You\u2019ve already entered today. Come back tomorrow for another go.'
            : j.alreadyToday ? 'You\u2019ve entered today but haven\u2019t confirmed yet. ' + (j.resent ? 'We\u2019ve sent the email again.' : 'Check your inbox (and spam folder) for our email.')
            : 'Nearly there: check your email and click the link to confirm your entry. It only counts once you do.';
          if (window.xm26Track) window.xm26Track('xmas26_free_entry', { ok: !!j.ok });
        })
        .catch(function () { msg.hidden = false; msg.textContent = 'That didn\u2019t work. Check your connection and try again.'; })
        .then(function () { btn.disabled = false; });
    });
  })();

  // Who walks from the shop to the High Street, and from where.
  d.addEventListener('click', function (e) { var a = e.target.closest && e.target.closest('a[href*="view=xmas26-street"]'); if (a) { var s0 = a.closest('.shopify-section'); window.xm26Track('xmas26_street_visit', { xm_place: s0 ? s0.id.replace(/^shopify-section-template--\d+__/, '') : '' }); } });
  d.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.xm [data-xm-add]'); if (!btn) return;
    e.preventDefault();
    var cart = d.querySelector('cart-drawer');
    var sections = cart && cart.getSectionsToRender ? cart.getSectionsToRender().map(function (s) { return s.id; }) : [];
    var props = { _source: 'xmas26' };
    if (btn.getAttribute('data-preorder') === 'true') { props._preorder = 'true'; var rd = btn.getAttribute('data-release-date'); if (rd) props._release_date = rd; }
    var body = { items: [{ id: +btn.getAttribute('data-xm-add'), quantity: 1, properties: props }] };
    if (sections.length) { body.sections = sections; body.sections_url = location.pathname; }
    btn.setAttribute('aria-busy', 'true');
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        btn.removeAttribute('aria-busy');
        if (res && res.status) {
          // Only a real sell-out keeps the button off. Other refusals (already at the stock or order limit
          // in the basket) say so briefly, then the button comes back. Shopify's message is translated on
          // /de-de etc., so a 422 counts as sold out when not even one is in the basket.
          var why = res.description || res.message || '';
          var vid = +btn.getAttribute('data-xm-add');
          var inCart = res.status === 422
            ? fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); })
                .then(function (c) { return (c.items || []).some(function (it) { return it.variant_id === vid; }); })
                .catch(function () { return true; })
            : Promise.resolve(true);
          return inCart.then(function (has) {
          var soldOut = res.status === 422 && !has;
          announce(why || 'That item couldn\u2019t be added. Please try again.');
          var l0 = btn.querySelector('span'); var was = l0 ? (l0.getAttribute('data-was') || l0.textContent) : 'Add';
          if (l0) { l0.setAttribute('data-was', was); l0.textContent = soldOut ? 'Sold out' : (res.status === 422 ? 'Max in basket' : 'Try again'); }
          if (why) btn.title = why;
          btn.disabled = true;
          if (!soldOut) setTimeout(function () { btn.disabled = false; btn.removeAttribute('title'); if (l0) l0.textContent = was; }, 4000);
          });
        }
        announce('Added to your basket.');
        try { if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'xm26', cartData: res }); } catch (x) {}
        btn.classList.add('is-done'); var lbl = btn.querySelector('span'); if (lbl) { if (!lbl.getAttribute('data-was')) lbl.setAttribute('data-was', lbl.textContent); lbl.textContent = 'Added'; }
        setTimeout(function () { btn.classList.remove('is-done'); if (lbl) lbl.textContent = lbl.getAttribute('data-was') || 'Add'; }, 2400);
        var sec = btn.closest('[data-st-name], dialog[data-decor], .xm-st-door, .shopify-section');
        window.xm26Track('xmas26_add_to_cart', { variant_id: String(body.items[0].id), xm_place: sec ? (sec.getAttribute('data-st-name') || (sec.getAttribute('data-decor') ? 'shop:' + sec.getAttribute('data-decor') : sec.classList.contains('xm-st-door') ? 'advent-door' : (sec.id || '').replace(/^shopify-section-template--\d+__/, ''))) : '' });
        // One confirmation: refresh the drawer and the header count quietly, and let the ticket bar say "added".
        quietRender(cart, res);
        refreshBasket(btn.closest('.xm-card') && btn.closest('.xm-card').querySelector('.xm-card__title'));
      })
      .catch(function () { btn.removeAttribute('aria-busy'); announce('That didn\u2019t work. Check your connection and try again.'); });
  });

  /* ── Gift finder ── */
  var finder = d.querySelector('[data-xm-finder]');
  if (finder) {
    var F = null; try { F = JSON.parse(finder.getAttribute('data-xm-finder')); } catch (e) { F = { who: {}, budget: {}, src: '' }; }
    Object.keys(F.who).forEach(function (k) { if (typeof F.who[k] === 'string') F.who[k] = F.who[k].split(/\r?\n/).map(function (x) { return x.trim(); }).filter(Boolean); });
    var pool = null, loading = null, page = 8;
    var out = finder.querySelector('.xm-finder__results'), count = finder.querySelector('.xm-finder__count'), more = finder.querySelector('[data-xm-more]');
    function load() {
      if (loading) return loading;
      out.innerHTML = new Array(8).join('<div class="xm-finder__skeleton"></div>') + '<div class="xm-finder__skeleton"></div>';
      loading = fetch(F.src, { headers: { Accept: 'text/html' } }).then(function (r) { return r.text(); }).then(function (html) {
        var box = d.createElement('div'); box.innerHTML = html;
        pool = [].slice.call(box.querySelectorAll('[data-xm-item]')).map(function (el) {
          return { el: el.firstElementChild, tags: (el.getAttribute('data-tags') || '').split('|'), price: +el.getAttribute('data-price') / 100 / parseFloat(cur.rate || 1), avail: el.getAttribute('data-avail') === '1' };
        });
      });
      return loading;
    }
    function state() {
      var who = finder.querySelector('input[name=xm-who]:checked'), budget = finder.querySelector('input[name=xm-budget]:checked');
      return { who: who && who.value, budget: budget && budget.value };
    }
    function run(reset) {
      if (reset) page = 8;
      load().then(function () {
        var s = state(), tags = s.who ? F.who[s.who] : null, b = s.budget ? F.budget[s.budget] : null;
        var hits = pool.filter(function (p) {
          if (!p.avail) return false;
          if (tags && !p.tags.some(function (t) { return tags.indexOf(t) > -1; })) return false;
          if (b && (p.price < b[0] || p.price >= b[1])) return false;
          return true;
        });
        count.textContent = hits.length ? hits.length + (hits.length === 1 ? ' gift' : ' gifts') + ' to choose from' : 'Nothing in that budget yet';
        out.innerHTML = '';
        hits.slice(0, page).forEach(function (p) { out.appendChild(p.el.cloneNode(true)); });
        more.hidden = hits.length <= page;
        // Thin result? Show the nearest-priced matches just outside the budget rather than a dead end.
        if (hits.length < 4 && b && tags) {
          var mid = (b[0] + Math.min(b[1], b[0] + 30)) / 2;
          var near = pool.filter(function (p) { return p.avail && hits.indexOf(p) < 0 && p.tags.some(function (t) { return tags.indexOf(t) > -1; }); })
            .sort(function (x, y) { return Math.abs(x.price - mid) - Math.abs(y.price - mid); }).slice(0, 4 - hits.length + 4);
          if (near.length) {
            var h = d.createElement('p'); h.className = 'xm-finder__near'; h.textContent = 'Close to your budget'; out.appendChild(h);
            near.forEach(function (p) { out.appendChild(p.el.cloneNode(true)); });
          }
        }
      });
    }
    if (cur.active !== 'GBP') {
      var whole = function (gbp) { var v = Math.max(5, Math.round(gbp * parseFloat(cur.rate || 1) / 5) * 5); try { return new Intl.NumberFormat(d.documentElement.lang || 'en', { style: 'currency', currency: cur.active, maximumFractionDigits: 0 }).format(v); } catch (e) { return v; } };
      var lab = { a: 'Under ' + whole(15), b: whole(15) + ' to ' + whole(30), c: whole(30) + ' or more' };
      // Filter on the same rounded local amounts the labels show (prices are compared in GBP).
      var r = parseFloat(cur.rate || 1), lo = Math.max(5, Math.round(15 * r / 5) * 5) / r, hi = Math.max(5, Math.round(30 * r / 5) * 5) / r;
      F.budget = { a: [0, lo], b: [lo, hi], c: [hi, 1e9] };
      finder.querySelectorAll('input[name=xm-budget]').forEach(function (i) { i.nextElementSibling.textContent = lab[i.value]; });
    }
    finder.addEventListener('change', function () { run(true); });
    more.addEventListener('click', function () { page += 8; run(false); });
    if ('IntersectionObserver' in window) {
      var fio = new IntersectionObserver(function (es) { if (es[0].isIntersecting) { fio.disconnect(); run(true); } }, { rootMargin: '400px' });
      fio.observe(finder);
    } else run(true);
  }

  /* ── Recipient tiles open the gift finder on an answer ── */
  d.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-xm-preset]'); if (!t) return;
    var f = d.querySelector('[data-xm-finder]'); if (!f) return;
    var want = t.getAttribute('data-xm-preset').trim().toLowerCase();
    var input = [].slice.call(f.querySelectorAll('input[name=xm-who]')).filter(function (i) { return i.nextElementSibling.textContent.trim().toLowerCase() === want; })[0];
    if (!input) return;
    e.preventDefault();
    input.checked = true; input.dispatchEvent(new Event('change', { bubbles: true }));
    f.scrollIntoView({ behavior: smooth, block: 'start' });
  });

  /* ── Hamper builder ── */
  d.querySelectorAll('[data-xm-hamper]').forEach(function (h) {
    var H = { min: 3, name: 'My British Christmas box', step: 10 }; try { H = JSON.parse(h.getAttribute('data-xm-hamper')); } catch (e) {}
    var picks = [].slice.call(h.querySelectorAll('[data-xm-pick]')), slots = [].slice.call(h.querySelectorAll('.xm-hamper__slots i'));
    var cnt = h.querySelector('[data-xm-h-count]'), tot = h.querySelector('[data-xm-h-total]'), tix = h.querySelector('[data-xm-h-tickets]'), add = h.querySelector('[data-xm-h-add]');
    function chosen() { return picks.filter(function (p) { return p.getAttribute('aria-pressed') === 'true'; }); }
    function paint() {
      var c = chosen(), sum = c.reduce(function (a, p) { return a + +p.getAttribute('data-price'); }, 0);
      var need = Math.max(H.min, c.length), box = h.querySelector('.xm-hamper__slots');
      while (box.children.length < need && box.children.length < 8) box.appendChild(d.createElement('i'));
      slots = [].slice.call(box.children);
      slots.forEach(function (s, i) { s.classList.toggle('on', i < c.length); s.innerHTML = ''; if (c[i]) { var im = c[i].querySelector('img'); if (im) { var cl = im.cloneNode(); cl.removeAttribute('srcset'); cl.removeAttribute('sizes'); s.appendChild(cl); } } });
      cnt.textContent = c.length < H.min ? (c.length ? c.length + ' picked, ' + (H.min - c.length) + ' more to go' : 'Pick ' + H.min + ' or more') : c.length + ' items in your box';
      tot.textContent = money(sum);
      var n = Math.floor(sum / cleanLocal(H.step));
      tix.textContent = n && d.querySelector('[data-xm-basket]:not([hidden])') ? 'Earns ' + n + (n === 1 ? ' ticket' : ' tickets') + ' in the Christmas draw' : '';
      add.disabled = c.length < H.min;
    }
    picks.forEach(function (p) { p.addEventListener('click', function () { p.setAttribute('aria-pressed', p.getAttribute('aria-pressed') === 'true' ? 'false' : 'true'); paint(); }); });
    h.querySelectorAll('[data-xm-starter]').forEach(function (b) {
      b.addEventListener('click', function () {
        var ids = b.getAttribute('data-xm-starter').split(',');
        picks.forEach(function (p) { p.setAttribute('aria-pressed', ids.indexOf(p.getAttribute('data-pid')) > -1 ? 'true' : 'false'); });
        paint();
      });
    });
    add.addEventListener('click', function () {
      var c = chosen(); if (c.length < H.min) return;
      var cart = d.querySelector('cart-drawer');
      var body = { items: c.map(function (p) { return { id: +p.getAttribute('data-xm-pick'), quantity: 1, properties: { _hamper: H.name, _source: 'xmas26' } }; }) };
      var sections = cart && cart.getSectionsToRender ? cart.getSectionsToRender().map(function (s) { return s.id; }) : [];
      if (sections.length) { body.sections = sections; body.sections_url = location.pathname; }
      add.disabled = true; add.setAttribute('aria-busy', 'true');
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' }, body: JSON.stringify(body) })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          add.removeAttribute('aria-busy');
          if (res && res.status) { announce(res.description || 'Some items couldn\u2019t be added.'); add.disabled = false; return; }
          announce(c.length + ' items added to your basket.');
          try { window.dataLayer = window.dataLayer || []; window.dataLayer.push({ event: 'xmas26_hamper', items: c.length }); } catch (x) {}
          try { if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'xm26', cartData: res }); } catch (x) {}
          if (cart && cart.renderContents && res.sections) { cart.classList.remove('is-empty'); cart.renderContents(res); }
          picks.forEach(function (p) { p.setAttribute('aria-pressed', 'false'); }); paint(); refreshBasket();
        })
        .catch(function () { add.disabled = false; add.removeAttribute('aria-busy'); announce('That didn\u2019t work. Check your connection and try again.'); });
    });
    paint();
    var sum = h.querySelector('.xm-hamper__sum'), grid = h.querySelector('.xm-hamper__picks');
    if (sum && grid && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        var on = es[0].isIntersecting && innerWidth <= 900;
        sum.classList.toggle('is-docked', on); d.body.classList.toggle('xm-hamper-docked', on);
      }, { rootMargin: '-40% 0px -20% 0px' }).observe(grid);
    }
  });

  /* ── Prize form: marketing opt-in is separate and unticked ── */
  d.querySelectorAll('[data-xm-optin]').forEach(function (cb) {
    cb.form && cb.form.addEventListener('submit', function () { var h = cb.form.querySelector('[data-xm-tags]'); if (h && cb.checked && h.value.indexOf('newsletter') < 0) h.value += ',newsletter'; });
  });

  /* ── Cracker: pull with resistance, snap, reveal ── */
  var cr = d.querySelector('[data-xm-cracker]');
  if (cr) (function () {
    var C = { odds: [40, 25, 18, 10, 7], demo: true }; try { C = JSON.parse(cr.getAttribute('data-xm-cracker')); } catch (e) {}
    var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
    var toy = cr.querySelector('[data-xm-toy]'), stage = cr.querySelector('[data-xm-stage]');
    var L = cr.querySelector('[data-half="l"]'), R = cr.querySelector('[data-half="r"]');
    var flash = cr.querySelector('.xm-cracker__flash'), hint = cr.querySelector('[data-xm-hint]');
    var crown = cr.querySelector('[data-xm-crown]'), slip = cr.querySelector('.xm-cracker__slip'), ticket = cr.querySelector('.xm-cracker__ticket');
    var qEl = cr.querySelector('[data-xm-q]'), aBtn = cr.querySelector('[data-xm-a]'), won = cr.querySelector('[data-xm-won]'), serial = cr.querySelector('[data-xm-serial]');
    var soundBtn = cr.querySelector('[data-xm-sound]'), again = cr.querySelector('[data-xm-again]');
    var JOKES = [
      ['Why did the turkey join the band?', 'Because it had the drumsticks.'],
      ['What do you call a cat on the beach at Christmas?', 'Sandy Claws.'],
      ['What do snowmen eat for breakfast?', 'Frosted Flakes.'],
      ['Why is it so cold at Christmas?', 'Because it’s in Decembrrr.'],
      ['Who hides in the bakery at Christmas?', 'A mince spy.'],
      ['What do you get if you eat Christmas decorations?', 'Tinsellitis.'],
      ['Why was the Christmas tree bad at knitting?', 'It kept dropping its needles.'],
      ['How does Christmas Day end?', 'With the letter Y.']
    ];
    var state = 'idle', side = 0, startX = 0, lastX = 0, lastT = 0, vel = 0, pull = 0, held = 0, fails = 0, raf = 0;
    var MAX = 58, K = 24;  // K: how quickly resistance builds; ~140px of drag reaches the snap point

    /* sound: synthesised, off by default */
    var soundOn = store.get('xm26-sound') === '1', ac = null;
    function paintSound() { soundBtn.setAttribute('aria-pressed', soundOn); soundBtn.textContent = 'Sound: ' + (soundOn ? 'on' : 'off'); }
    paintSound();
    soundBtn.addEventListener('click', function () { soundOn = !soundOn; store.set('xm26-sound', soundOn ? '1' : '0'); paintSound(); });
    function noise(dur, freq, q, gain, delay) {
      if (!soundOn) return;
      try {
        ac = ac || new (window.AudioContext || window.webkitAudioContext)();
        var len = Math.floor(ac.sampleRate * dur), buf = ac.createBuffer(1, len, ac.sampleRate), ch = buf.getChannelData(0);
        for (var i = 0; i < len; i++) ch[i] = (Math.random() * 2 - 1) * Math.pow(1 - i / len, 3);
        var src = ac.createBufferSource(), f = ac.createBiquadFilter(), g = ac.createGain();
        src.buffer = buf; f.type = 'bandpass'; f.frequency.value = freq * (0.94 + Math.random() * 0.12); f.Q.value = q; g.gain.value = gain;
        src.connect(f); f.connect(g); g.connect(ac.destination); src.start(ac.currentTime + (delay || 0));
      } catch (e) {}
    }
    function ding() {
      if (!soundOn) return;
      try { ac = ac || new (window.AudioContext || window.webkitAudioContext)(); var o = ac.createOscillator(), g = ac.createGain(); o.frequency.value = 1320; g.gain.setValueAtTime(0.12, ac.currentTime); g.gain.exponentialRampToValueAtTime(0.0001, ac.currentTime + 0.8); o.connect(g); g.connect(ac.destination); o.start(); o.stop(ac.currentTime + 0.8); } catch (e) {}
    }
    function buzz(p) { try { if (navigator.vibrate) navigator.vibrate(p); } catch (e) {} }

    function band(dx) { return MAX * (1 - 1 / (Math.max(0, dx) / K + 1)); }
    function paint(p, jitter) {
      var t = p / MAX, j = jitter ? (Math.random() - 0.5) * t * 2.2 : 0;
      var own = side < 0 ? L : R, other = side < 0 ? R : L;
      own.style.transform = 'translateX(' + (side * p + j) + 'px)';
      other.style.transform = 'translateX(' + (-side * p * 0.35 - j) + 'px)';
      toy.style.setProperty('--t', t.toFixed(3));
    }
    function loop() {
      if (state !== 'straining') return;
      var t = pull / MAX;
      paint(pull, t > 0.6 && !reduce);
      if (t > 0.7 && Date.now() % 90 < 17) buzz(4);
      if (t >= 0.85) { held += 16; if (held > 110) return snap(); } else held = 0;
      raf = requestAnimationFrame(loop);
    }
    function springBack() {
      state = 'idle'; cr.classList.remove('is-pulling'); held = 0;
      [L, R].forEach(function (h) {
        var from = h.style.transform || 'translateX(0px)';
        if (h.animate && !reduce) h.animate([{ transform: from }, { transform: 'translateX(' + (h === L ? 6 : -6) + 'px)' }, { transform: 'translateX(-2px)' }, { transform: 'translateX(0px)' }], { duration: 520, easing: 'cubic-bezier(.34,1.56,.64,1)' });
        h.style.transform = '';
      });
      toy.style.setProperty('--t', 0);
      if (++fails === 2 && hint) { hint.lastChild.textContent = 'harder!'; }
    }

    toy.addEventListener('pointerdown', function (e) {
      if (state !== 'idle') return;
      var r = toy.getBoundingClientRect(); side = e.clientX < r.left + r.width / 2 ? -1 : 1;
      startX = lastX = e.clientX; lastT = e.timeStamp; vel = 0; pull = 0;
      state = 'grabbing'; try { toy.setPointerCapture(e.pointerId); } catch (x) {}
    });
    toy.addEventListener('pointermove', function (e) {
      if (state !== 'grabbing' && state !== 'straining') return;
      var dx = (e.clientX - startX) * side;
      if (state === 'grabbing' && Math.abs(e.clientX - startX) > 6) { state = 'straining'; cr.classList.add('is-pulling'); raf = requestAnimationFrame(loop); }
      pull = band(dx);
      var dt = Math.max(1, e.timeStamp - lastT); vel = ((e.clientX - lastX) * side) / dt; lastX = e.clientX; lastT = e.timeStamp;
    });
    function release() {
      if (state === 'grabbing') { state = 'idle'; return autoPull(); }
      if (state !== 'straining') return;
      cancelAnimationFrame(raf);
      if (pull / MAX > 0.55 && vel > 0.8) return snap();
      springBack();
    }
    toy.addEventListener('pointerup', release);
    toy.addEventListener('pointercancel', function () { if (state === 'straining' || state === 'grabbing') { cancelAnimationFrame(raf); springBack(); } });
    toy.addEventListener('click', function (e) { if (e.detail === 0 && state === 'idle') autoPull(); });

    function autoPull() {
      if (state !== 'idle') return;
      if (reduce) { side = 1; return snap(); }
      state = 'auto'; side = side || 1; cr.classList.add('is-pulling');
      var t0 = performance.now();
      (function step(now) {
        var k = Math.min(1, (now - t0) / 700), p = MAX * 0.95 * (1 - Math.pow(1 - k, 2));
        paint(p, k > 0.5);
        if (k > 0.6 && Math.random() < 0.2) buzz(4);
        if (k < 1) requestAnimationFrame(step); else snap();
      })(t0);
    }

    function result() {
      if (C.demo || !C.endpoint) {
        var r = Math.random() * 100, acc = 0, n = 1;
        for (var i = 0; i < C.odds.length; i++) { acc += C.odds[i]; if (r < acc) { n = i + 1; break; } }
        return Promise.resolve({ tickets: n, joke: JOKES[Math.floor(Math.random() * JOKES.length)] });
      }
      return fetch(C.endpoint, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ token: new URLSearchParams(location.search).get('t') }) })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
        .then(function (j) { if (!(j.tickets > 0)) throw new Error('bad'); var jk = String(j.joke || '').split('|'); return { tickets: j.tickets, joke: jk.length === 2 ? jk : JOKES[0] }; });
    }

    function snap() {
      if (state === 'snapped' || state === 'revealed') return;
      state = 'snapped'; cancelAnimationFrame(raf);
      var got = result();
      cr.classList.remove('is-pulling'); cr.classList.add('is-snapped');
      noise(0.09, 2600, 0.7, 0.9); noise(0.35, 900, 0.5, 0.25, 0.12);
      buzz([30, 40, 60]);
      var big = side || 1;
      if (reduce || !L.animate) {
        L.style.transform = 'translateX(-90px) rotate(8deg)'; R.style.transform = 'translateX(90px) rotate(-8deg)';
      } else {
        var fl = L.style.transform || 'translateX(0px)', fr = R.style.transform || 'translateX(0px)';
        var span = Math.min(210, stage.clientWidth * (stage.clientWidth < 600 ? 0.1 : 0.18)), dl = big < 0 ? span : span * 0.72, dr = big > 0 ? span : span * 0.72;
        L.animate([{ transform: fl }, { transform: 'translateX(-' + dl + 'px) translateY(18px) rotate(24deg)' }], { duration: 480, easing: 'cubic-bezier(.16,1,.3,1)', fill: 'forwards' });
        R.animate([{ transform: fr }, { transform: 'translateX(' + dr + 'px) translateY(14px) rotate(-20deg)' }], { duration: 480, easing: 'cubic-bezier(.16,1,.3,1)', fill: 'forwards' });
        flash.animate([{ opacity: 1, transform: 'scale(0)' }, { opacity: 0, transform: 'scale(1.8)' }], { duration: 260, easing: 'ease-out' });
        stage.animate([{ transform: 'translateX(0)' }, { transform: 'translateX(-4px)' }, { transform: 'translateX(4px)' }, { transform: 'translateX(-2px)' }, { transform: 'translateX(0)' }], { duration: 180 });
        burst();
      }
      got.then(reveal).catch(function () {
        state = 'idle'; cr.classList.remove('is-snapped');
        [L, R].forEach(function (h) { h.getAnimations && h.getAnimations().forEach(function (a) { a.cancel(); }); h.style.transform = ''; });
        announce('That didn’t work. Try again in a moment.');
      });
    }

    function burst() {
      var canvas = cr.querySelector('.xm-cracker__fx');
      var go = function () {
        if (!window.confetti || !canvas) return;
        var fire = window.confetti.create(canvas, { resize: true, useWorker: true });
        var shapes = ['square', 'circle'];
        try { if (window.confetti.shapeFromPath) shapes.push(window.confetti.shapeFromPath({ path: 'M12 0c1 4 5 5 8 4-2 3-1 7 2 9-4 0-6 3-6 7-2-3-6-3-8-1 1-4-1-7-5-8 4-1 5-5 4-9 2 2 4 1 5-2z' })); } catch (e) {}
        var base = { particleCount: 45, spread: 55, startVelocity: 30, gravity: 0.9, decay: 0.92, ticks: 190, scalar: 0.9, shapes: shapes, colors: ['#cd3d1c', '#c7a25a', '#23665b', '#f6f0e4'], origin: { x: 0.5, y: 0.42 }, disableForReducedMotion: true };
        fire(Object.assign({}, base, { angle: 150 })); fire(Object.assign({}, base, { angle: 30 }));
      };
      if (window.confetti) return go();
      var sc = d.createElement('script'); sc.src = cr.getAttribute('data-confetti'); /* self-hosted canvas-confetti 1.9.3 */ sc.onload = go; d.head.appendChild(sc);
    }

    function scramble(el, target, ms) {
      if (reduce) { el.textContent = target; return; }
      var t0 = performance.now(), chars = '0123456789';
      (function step(now) {
        var k = Math.min(1, (now - t0) / ms), out = '';
        for (var i = 0; i < target.length; i++) out += (i / target.length < k || !/\d/.test(target[i])) ? target[i] : chars[Math.floor(Math.random() * 10)];
        el.textContent = out; if (k < 1) requestAnimationFrame(step);
      })(t0);
    }

    function reveal(res) {
      state = 'revealed'; cr.classList.add('is-revealed');
      qEl.textContent = res.joke[0]; aBtn.textContent = 'Tap for the answer'; aBtn.classList.remove('is-open'); aBtn.disabled = false; aBtn.dataset.answer = res.joke[1];
      var sn = String(Math.floor(100000 + Math.random() * 899999));
      var anim = function (el, frames, opts) { if (!el) return; if (reduce || !el.animate) { el.style.opacity = 1; el.style.transform = frames[frames.length - 1].transform || ''; el.style.clipPath = 'inset(0 0 0 0)'; return; } el.animate(frames, Object.assign({ fill: 'forwards', easing: 'cubic-bezier(.34,1.56,.64,1)' }, opts)); };
      anim(crown, [{ opacity: 0, transform: 'translateY(80px) rotate(0deg) scale(.4)' }, { opacity: 1, transform: 'translateY(-30px) rotate(300deg) scale(.9)', offset: .6 }, { opacity: 1, transform: 'translateY(0) rotate(-8deg) scale(1)' }], { duration: 900, delay: 120 });
      anim(slip, [{ clipPath: 'inset(0 100% 0 0)' }, { clipPath: 'inset(0 0 0 0)' }], { duration: 520, delay: 650, easing: 'cubic-bezier(.2,.7,.2,1)' });
      anim(ticket, [{ opacity: 0, transform: 'translate(-50%, 30px) rotate(2deg)' }, { opacity: 1, transform: 'translate(-50%, 0) rotate(2deg)' }], { duration: 560, delay: 1050 });
      setTimeout(function () {
        serial.textContent = 'No. ' + sn;
        scramble(won, '+' + res.tickets + (res.tickets === 1 ? ' bonus ticket' : ' bonus tickets'), 700);
        ding();
      }, reduce ? 0 : 1150);
      announce('You won ' + res.tickets + (res.tickets === 1 ? ' bonus ticket. ' : ' bonus tickets. ') + res.joke[0]);
      if (again) again.hidden = false;
    }

    aBtn.addEventListener('click', function () { if (aBtn.classList.contains('is-open')) return; aBtn.textContent = aBtn.dataset.answer || ''; aBtn.classList.add('is-open'); aBtn.disabled = true; noise(0.05, 3200, 1, 0.2); });

    if (crown) crown.addEventListener('click', function () {
      var logo = d.querySelector('.header-logo img, .header-logo svg, .header__heading-logo, .header-logo a, .header-logo');
      if (!logo) return;
      var old = d.querySelector('.xm-crown-worn'); if (old) old.remove();
      var img = crown.querySelector('img').cloneNode(); img.className = 'xm-crown-worn';
      var place = function () { var r = logo.getBoundingClientRect(); img.style.left = (r.left - 12) + 'px'; img.style.top = Math.max(2, r.top - 20) + 'px'; img.style.display = r.bottom > 0 ? '' : 'none'; };
      d.body.appendChild(img); place();
      addEventListener('scroll', function () { requestAnimationFrame(place); }, { passive: true }); addEventListener('resize', place);
      crown.querySelector('span').textContent = 'Suits you';
      try { sessionStorage.setItem('xm26-crown', '1'); } catch (e) {}
      noise(0.2, 700, 0.6, 0.3);
    });

    if (again) again.addEventListener('click', function () {
      state = 'idle'; fails = 0; cr.classList.remove('is-snapped', 'is-revealed');
      [L, R, crown, slip, ticket, flash].forEach(function (el) { if (!el) return; el.getAnimations && el.getAnimations().forEach(function (a) { a.cancel(); }); el.style.transform = ''; el.style.opacity = ''; el.style.clipPath = ''; });
      won.textContent = ''; toy.style.setProperty('--t', 0); again.hidden = true;
      if (hint) hint.lastChild.textContent = hint.getAttribute('data-default') || hint.lastChild.textContent;
    });
    if (hint) hint.setAttribute('data-default', hint.lastChild.textContent);

    /* A small wiggle to invite a pull, three times at most, only while in view */
    if (!reduce && 'IntersectionObserver' in window) {
      var wig = 0, timer = 0;
      new IntersectionObserver(function (es) {
        clearInterval(timer);
        if (!es[0].isIntersecting) return;
        timer = setInterval(function () {
          if (state !== 'idle' || wig >= 3 || !toy.animate) return clearInterval(timer);
          wig++; toy.animate([{ transform: 'translate(-50%,-50%) rotate(-4deg)' }, { transform: 'translate(-50%,-50%) rotate(-1deg)' }, { transform: 'translate(-50%,-50%) rotate(-6deg)' }, { transform: 'translate(-50%,-50%) rotate(-4deg)' }], { duration: 550, easing: 'cubic-bezier(.34,1.56,.64,1)' });
        }, 3500);
      }, { threshold: 0.6 }).observe(stage);
    }
  })();
})();
